import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';

const UpgradeModal = ({ isOpen, toggle, currentSubscription, onUpgradeConfirm, selectedPlan }) => {
    const [upgradeCost, setUpgradeCost] = useState(0);

    useEffect(() => {
        if (currentSubscription && selectedPlan) {
            const currentPrice = currentSubscription.price;
            const newPrice = selectedPlan.price;
            const remainingDays = Math.max(
                0,
                Math.floor((new Date(currentSubscription.expiryDate) - new Date()) / (1000 * 60 * 60 * 24))
            );
            const totalDays = 30; // assuming monthly
            const proratedValue = (currentPrice / totalDays) * remainingDays;
            const costToUpgrade = Math.max(newPrice - proratedValue, 0);
            setUpgradeCost(costToUpgrade.toFixed(2));
        }
    }, [currentSubscription, selectedPlan]);

    return (
        <Modal centered isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Upgrade to {selectedPlan?.title}</ModalHeader>
            <ModalBody>
                <div className="d-flex flex-wrap gap-3">
                    {/* Current Plan Tile */}
                    <Card className="flex-fill">
                        <CardBody>
                            <CardTitle tag="h5">Current Plan</CardTitle>
                            <CardText><strong>Price:</strong> ${currentSubscription?.price}</CardText>
                            <CardText><strong>Expiry Date:</strong> {new Date(currentSubscription?.expiryDate).toLocaleDateString()}</CardText>
                            <CardText><strong>Remaining Days:</strong> {
                                Math.max(0, Math.floor((new Date(currentSubscription?.expiryDate) - new Date()) / (1000 * 60 * 60 * 24)))
                            }</CardText>
                        </CardBody>
                    </Card>

                    {/* New Plan Tile */}
                    <Card className="flex-fill">
                        <CardBody>
                            <CardTitle tag="h5">New Plan</CardTitle>
                            <CardText><strong>Price:</strong> ${selectedPlan?.price}</CardText>
                            <CardText><strong>Description:</strong> {selectedPlan?.description}</CardText>
                        </CardBody>
                    </Card>
                </div>

                {/* Cost Breakdown Tile */}
                <Card className="mt-3">
                    <CardBody>
                        <CardTitle tag="h5">Upgrade Cost Breakdown</CardTitle>
                        <CardText><strong>Prorated Value:</strong> -${(currentSubscription?.price / 30 * Math.max(0, Math.floor((new Date(currentSubscription?.expiryDate) - new Date()) / (1000 * 60 * 60 * 24)))).toFixed(2)}</CardText>
                        <CardText><strong>Cost to Upgrade:</strong> ${upgradeCost}</CardText>
                    </CardBody>
                </Card>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>Cancel</Button>
                <Button color="success" onClick={() => onUpgradeConfirm(selectedPlan._id)}>Upgrade</Button>
            </ModalFooter>
        </Modal>
    );
};

export default UpgradeModal;
